import { CHALLENGE_DURATION_MAP } from './calculatorConstants';
import { calculateMilestonesCount, calculateTranchesCount } from './calculatorHelpers';
import {
  DEFAULT_TEAM_COMPOSITION,
  applyServicesToTeam,
  buildInitialTeamForChallenge,
} from './teamComposition';
import type { CalculatorFormState } from './types';

export const initialFormState: CalculatorFormState = {
  challenges: [],
  services: [],
  workshopType: '',
  technologiesText: '',
  email: '',
  acceptTerms: false,
  teamComposition: DEFAULT_TEAM_COMPOSITION,
  projectDuration: 1,
  milestones: 1,
};

export type CalculatorAction =
  | { type: 'SELECT_CHALLENGE'; payload: string }
  | { type: 'TOGGLE_SERVICE'; payload: string }
  | { type: 'SET_WORKSHOP_TYPE'; payload: string }
  | { type: 'SET_TECHNOLOGIES_TEXT'; payload: string }
  | { type: 'SET_EMAIL'; payload: string }
  | { type: 'TOGGLE_TERMS' };

export const calculatorReducer = (
  state: CalculatorFormState,
  action: CalculatorAction,
): CalculatorFormState => {
  switch (action.type) {
    case 'SELECT_CHALLENGE': {
      const challenge = action.payload;
      const newDuration = CHALLENGE_DURATION_MAP[challenge] || 1;
      const trancheCount = calculateTranchesCount(newDuration);
      const milestones = calculateMilestonesCount(trancheCount);

      const baseTeam = buildInitialTeamForChallenge(state.teamComposition, challenge);
      const teamComposition =
        state.services.length > 0
          ? applyServicesToTeam(baseTeam, state.services, challenge)
          : baseTeam;

      return {
        ...state,
        challenges: [challenge],
        projectDuration: newDuration,
        milestones,
        teamComposition,
      };
    }

    case 'TOGGLE_SERVICE': {
      const service = action.payload;
      const isSelected = state.services.includes(service);
      const newServices = isSelected
        ? state.services.filter(s => s !== service)
        : [...state.services, service];

      const selectedChallenge = state.challenges[0] || '';
      const teamComposition = applyServicesToTeam(
        state.teamComposition,
        newServices,
        selectedChallenge,
      );

      return {
        ...state,
        services: newServices,
        teamComposition,
      };
    }

    case 'SET_WORKSHOP_TYPE':
      return { ...state, workshopType: action.payload };

    case 'SET_TECHNOLOGIES_TEXT':
      return { ...state, technologiesText: action.payload };

    case 'SET_EMAIL':
      return { ...state, email: action.payload };

    case 'TOGGLE_TERMS':
      return { ...state, acceptTerms: !state.acceptTerms };

    default:
      return state;
  }
};
